import React, { ReactElement } from 'react';
import { Button, styled, SxProps } from '@mui/material';
import { StyledMediumTypography } from '../theme/StyledElements';
import { Add } from '@mui/icons-material';

const StyledAddButton = styled(Button)(() => ({
    width: '368px',
    height: '48px',
    background: '#E37F1E !important',
    borderRadius: '24px'
}));

interface AddButtonProps {
    disabled: boolean;
    title: string;
    onButtonClick: Function;
    sx?: SxProps;
}

export function AddButton({ disabled, title, onButtonClick, sx }: AddButtonProps): ReactElement {
    return (
        <StyledAddButton disabled={disabled} onClick={(): void => onButtonClick()} sx={sx}>
            <Add sx={{ color: '#FFFFFF', height: '18px', width: '18px' }} />
            <StyledMediumTypography
                variant="caption"
                color="#FFFFFF"
                sx={{ marginTop: '3px', marginLeft: '10px' }}>
                {title}
            </StyledMediumTypography>
        </StyledAddButton>
    );
}
